import { useState, useEffect, useMemo, useRef } from "react"
import moment from "moment"
import toast, { Toaster } from "react-hot-toast"
import axios from "axios"
import { useAuthState } from "react-firebase-hooks/auth"
import { Share2Icon } from "lucide-react"
import { useParams } from "react-router-dom"
import CryptoJS from "crypto-js"
import { ArrowUpRightIcon, BarChart3Icon, ArrowDownRightIcon, TimerIcon, ArrowRight, Eye } from "lucide-react"
import { TrendingUp } from "lucide-react"
import { Info } from "lucide-react"

import VolatilityIcon from "../../assests/volatility.svg"
import Alpha100 from "../../assests/alpha-100.png"
import RebalanceTimeLineModal from "../../AdminDashboard/StrategyDetailsPageSection/RebalanceTimeLineModal"
import { auth } from "../../firebase"
import server from "../../utils/serverConfig"
import UserStrategySubscribeModal from "./UserStrategySubscribeModal"
import RecommendationSuccessModal from "../StockRecommendation/RecommendationSuccessModal"
import ConnectBroker from "../LivePortfolioSection/connectBroker"
import Breadcrumb from "../../components/Breadcrumbs/Breadcrumbs"
import TokenExpireBrokarModal from "../RootSection/TokenExpireBrokarModal"
import { fetchFunds } from "../../FunctionCall/fetchFunds"
import PlanSubscribeModal from "../PricingSection/PlanSubscribeModal"
import PaymentSuccessModal from "../PricingSection/PaymentSuccessModal"
import { encryptApiKey } from "../../utils/cryptoUtils"
import appConfig from "../../utils/appConfig";

import { Chart, registerables } from "chart.js"
Chart.register(...registerables)

const style = {
  selected:
    "flex items-center text-[16px] md:text-[18px] font-sans text-[#1F54DB] font-bold lg:leading-[42px] border-b-[3px] border-[#1F54DB] cursor-pointer transition-all duration-200",
  unselected:
    "flex items-center text-[16px] md:text-[18px] font-sans font-medium text-[#000000]/40 lg:leading-[42px] cursor-pointer hover:text-[#1F54DB]/60 transition-all duration-200",
  firstHeading: "text-sm text-[#00000099] text-left font-medium",
  inputBox:
    "w-full px-6 py-2.5 bg-[#FAFBFF] text-[18px] peer text-gray-900 placeholder-transparent font-medium rounded-md mt-3 ring-[1px] hover:ring-[2px] ring-gray-200 hover:ring-[#1F54DB]/40 focus:outline-none focus:ring-2 focus:ring-[#1F54DB] transition ease-in duration-200",
  labelFloat:
    "absolute px-1.5 top-0.5 left-3.5 text-[#808080] bg-[#FAFBFF] text-[16px] peer-placeholder-shown:text-sm peer-placeholder-shown:font-medium peer-placeholder-shown:top-6 peer-placeholder-shown:text-[#808080] transition-all peer-focus:top-0.5 peer-focus:text-[#1F54DB] peer-focus:text-xs",
  selectDiv:
    "flex items-center px-2 py-2 hover:first-of-type:rounded-t-lg hover:last-of-type:rounded-b-lg first-of-type:rounded-t-lg last-of-type:rounded-b-lg md-3 text-gray-900 hover:bg-[#1F54DB] hover:text-white transition ease-in duration-200 cursor-pointer",
  inputStartDiv: "relative w-full",
};
const advisorTag = process.env.REACT_APP_ADVISOR_SPECIFIC_TAG;

const StrategyDetails = ({ ele }) => {
  const { fileName } = useParams();
  const razorPayKey = process.env.REACT_APP_RAZORPAY_LIVE_API_KEY;
  const [user] = useAuthState(auth);
  const userEmail = user?.email;

  // State declarations
  const [userDetails, setUserDetails] = useState(null);
  const [openSuccessModal, setOpenSucessModal] = useState(false);
  const [orderPlacementResponse, setOrderPlacementResponse] = useState();
  const [selectedDataTab, setSelectedDataTab] = useState("distribution");
  const [openSubscribeModel, setOpenSubscribeModel] = useState(false);
  const [strategyDetails, setStrategyDetails] = useState(null);
  const [latestRebalance, setLatestRebalance] = useState(null);
  const [broker, setBroker] = useState("");
  const [brokerModel, setBrokerModel] = useState(false);
  const [openTokenExpireModel, setOpenTokenExpireModel] = useState(null);
  const [showRebalanceTimelineModal, setShowRebalanceTimelineModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [specificPlan, setSpecificPlan] = useState();
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  const [invetAmount, setInvestAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [showAfterPlaceOrderDdpiModal, setShowAfterPlaceOrderDdpiModal] =
    useState(false);
  const [funds, setFunds] = useState(null);

  // Extract user details after state is set
  const userName = userDetails?.name;
  const clientCode = userDetails?.clientCode;
  const apiKey = userDetails?.apiKey;
  const jwtToken = userDetails?.jwtToken;
  const my2pin = userDetails?.my2Pin;
  const secretKey = userDetails?.secretKey;
  const userId = userDetails?._id;
  const viewToken = userDetails?.viewToken;
  const sid = userDetails?.sid;
  const serverId = userDetails?.serverId;
  const mobileNumber = userDetails?.phone_number;
  const panNumber = userDetails?.panNumber;
  const dateString = userDetails?.token_expire;
  const telegramId = userDetails?.telegram_id;
  const expireTokenDate = moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  const today = new Date();
  const todayDate = moment(today).format("YYYY-MM-DD HH:mm:ss");

  // 4. ADD THE FUNCTIONS HERE - AFTER STATE DECLARATIONS, BEFORE USEEFFECTS
  const checkValidApiAnSecret = (details) => {
    try {
      const bytesKey = CryptoJS.AES.decrypt(details, "ApiKeySecret")
      const Key = bytesKey.toString(CryptoJS.enc.Utf8) // Convert to UTF-8 string

      if (Key) {
        return Key
      } else {
        throw new Error("Decryption failed or invalid key.")
      }
    } catch (error) {
      console.error("Error during decryption:", error.message)
      return null
    }
  }

  async function subscribeToPlan(frequency, sip_amount) {
    try {
      setLoading(true)
      const response = await axios.post(
        `${server.server.baseUrl}api/admin/subscription`,
        {
          plan_id: planDetails._id,
          frequency,
          user_email: userEmail,
          sip_amount,
          advisor: advisorTag,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        },
      )
      setLoading(false)
      setPaymentModal(false)
      const subscriptionData = response.data.data

      if (subscriptionData.razorpay_subscription_id) {
        const options = {
          key: razorPayKey,
          subscription_id: subscriptionData.razorpay_subscription_id,
          name: subscriptionData.plan_id.name,
          description: subscriptionData.razorpay_subscription_id,
          amount: subscriptionData.amount,
          currency: "INR",
          handler: (response) => {
            console.log("Razorpay Payment ID:", response.razorpay_payment_id)
            console.log("Razorpay Subscription ID:", response.razorpay_subscription_id)
            console.log("Razorpay Signature:", response.razorpay_signature)

            if (userId) {
              completeSubscription(response)
            }
          },
          modal: {
            ondismiss: () => {
              alert("Payment was not completed. Please try again.")
            },
          },
          prefill: {
            name: "",
            email: userEmail,
          },
          theme: {
            color: "#1F54DB",
          },
        }

        const rzp = new window.Razorpay(options)
        rzp.open()
      } else {
        console.error("Error fetching subscription data")
        setLoading(true)
      }
    } catch (error) {
      console.error("Error subscribing to plan:", error)
      setLoading(true)
    }
  }

  async function completeSubscription(paymentDetails) {
    try {
      const response = await axios.post(
        `${server.server.baseUrl}api/admin/subscription/complete-payment`,
        paymentDetails,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        },
      )

      const data = response.data

      setPaymentSuccess(true)
      setRefresh((prev) => !prev)

      const newSubscription = {
        startDate: new Date(),
        plan: fileName || "",
        capital: data.subscription.capital || 0,
        charges: data.subscription.amount || 0,
        invoice: data.subscription.razorpay_subscription_id || "",
        expiry: new Date(data.expiry),
      }

      const newClientData = {
        clientName: userName || "",
        email: data.subscription.user_email || "",
        phone: mobileNumber || "",
        groups: [`All Client`, fileName],
        location: data.location || "",
        telegram: telegramId || "",
        pan: data.pan || "",
        creationDate: new Date(),
        comments: data.comments || "",
        subscriptions: [newSubscription],
      }

      try {
        const response = await fetch(`${server.ccxtServer.baseUrl}comms/add-new-client-to-groups`, {
          method: "POST",
          body: JSON.stringify({
            userId: planDetails?.adminId,
            clientData: newClientData,
          }),
          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        })

        const result = await response.json()
      } catch (error) {
        console.error("Error adding client:", error)
      }

      const payloadData = JSON.stringify({
        email: userEmail,
        action: "subscribe",
      })

      const config = {
        method: "put",
        url: `${server.server.baseUrl}api/model-portfolio/subscribe-strategy/${strategyDetails?._id}`,
        data: payloadData,
        headers: {
          "Content-Type": "application/json",
          "X-Advisor-Subdomain": process.env.REACT_APP_URL,
          "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
        },
      }

      axios
        .request(config)
        .then((response) => {
          getStrategyDetails()
        })
        .catch((error) => {
          console.log(error)
        })

      const data2 = JSON.stringify({
        userEmail: userEmail,
        model: strategyDetails?.model_name,
        advisor: strategyDetails?.advisor,
        model_id: latestRebalance.model_Id,
        userBroker: broker ? broker : "",
        subscriptionAmountRaw: [
          {
            amount: invetAmount,
            dateTime: new Date(),
          },
        ],
      })

      const config2 = {
        method: "post",
        url: `${server.ccxtServer.baseUrl}rebalance/insert-user-doc`,
        data: data2,
        headers: {
          "Content-Type": "application/json",
          "X-Advisor-Subdomain": process.env.REACT_APP_URL,
          "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
        },
      }

      axios
        .request(config2)
        .then((response) => {
          getStrategyDetails()
          toast.success("You have been successfully subscribed model portfolio.", {
            duration: 3000,
            style: {
              background: "white",
              color: "#1F54DB",
              maxWidth: "500px",
              fontWeight: "bolder",
              fontSize: "16px",
              padding: "10px 20px",
            },
            iconTheme: {
              primary: "#1F54DB",
              secondary: "#FFFAEE",
            },
          })
        })
        .catch((error) => {
          console.log(error)
        })
      getStrategyDetails()
    } catch (error) {
      console.error("Error completing subscription:", error)
    }
  }

  // Keep all the existing useEffects and functions
  useEffect(() => {
    if (userDetails) {
      setBroker(userDetails.user_broker)
    }
  }, [userDetails])

  const getUserDetails = () => {
    axios
      .get(`${server.server.baseUrl}api/user/getUser/${userEmail}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Advisor-Subdomain": process.env.REACT_APP_URL,
          "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
        },
      })
      .then((res) => {
        setUserDetails(res.data.User)
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    getUserDetails()
  }, [userEmail])

  const getStrategyDetails = () => {
    if (fileName) {
      axios
        .get(`${server.server.baseUrl}api/model-portfolio/portfolios/strategy/${fileName?.replaceAll(/_/g, " ")}`, {
          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        })
        .then((res) => {
          const portfolioData = res.data[0].originalData
          setStrategyDetails(portfolioData)
          if (portfolioData?.model?.rebalanceHistory?.length > 0) {
            const latest = portfolioData.model.rebalanceHistory.sort(
              (a, b) => new Date(b.rebalanceDate) - new Date(a.rebalanceDate),
            )[0]
            setLatestRebalance(latest)
          }
        })
        .catch((err) => console.log(err))
    }
  }

  useEffect(() => {
    getStrategyDetails()
  }, [fileName])

  const getPlanDetails = () => {
    if (fileName) {
      axios
        .get(`${server.server.baseUrl}api/all-plans/check-portfolio-plan/${fileName?.replaceAll(/_/g, " ")}`, {
          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        })
        .then((res) => {
          setPlanDetails(res.data)
        })
        .catch((err) => console.log(err))
    }
  }

  useEffect(() => {
    getPlanDetails()
  }, [fileName])

  const getAllFunds = async () => {
    const fetchedFunds = await fetchFunds(broker, clientCode, apiKey, jwtToken, secretKey)
    if (fetchedFunds) {
      setFunds(fetchedFunds)
    }
  }

  useEffect(() => {
    if (broker && (clientCode || jwtToken)) {
      getAllFunds()
    }
  }, [broker, clientCode, apiKey, jwtToken, secretKey])

  const subscribed = strategyDetails?.subscribed_by?.filter((email) => email === userEmail).length > 0

  const handleSubscribe = () => {
    setPaymentModal(true)
  }

  const handleCardClickSelect = (item) => {
    setSelectedCard(item)
  }

  const handleOk = () => {
    subscribeToPlan(selectedCard)
  }

  const colorPalette = [
    "#E8EAF6", // Light Indigo
    "#C5CAE9", // Lighter Indigo
    "#9FA8DA", // Light Indigo
    "#7986CB", // Indigo
    "#5C6BC0", // Indigo
    "#3F51B5", // Indigo
    "#3949AB", // Indigo
    "#303F9F", // Indigo
    "#283593", // Dark Indigo
    "#1A237E", // Darker Indigo
    "#E3F2FD", // Light Blue
    "#BBDEFB", // Lighter Blue
    "#90CAF9", // Light Blue
    "#64B5F6", // Blue
    "#42A5F5", // Blue
    "#2196F3", // Blue
    "#1E88E5", // Blue
    "#1976D2", // Blue
    "#1565C0", // Dark Blue
    "#0D47A1", // Darker Blue
    "#E1F5FE", // Light Light Blue
    "#B3E5FC", // Lighter Light Blue
    "#81D4FA", // Light Light Blue
    "#4FC3F7", // Light Blue
    "#29B6F6", // Light Blue
    "#03A9F4", // Light Blue
    "#039BE5", // Light Blue
    "#0288D1", // Light Blue
    "#0277BD", // Dark Light Blue
    "#01579B", // Darker Light Blue
  ]

  // Chart data preparation
  const { chartData, chartConfig, colorMap } = useMemo(() => {
    const colorMap = {}
    const data =
      latestRebalance?.adviceEntries?.map((entry, index) => {
        const color = colorPalette[index % colorPalette.length]
        colorMap[entry.symbol] = color
        return {
          shares: entry.symbol,
          value: entry.value * 100,
          fill: color,
        }
      }) || []

    const config = {
      value: { label: "Equity Distribution" },
      ...data.reduce((acc, entry) => {
        acc[entry.shares] = {
          label: entry.shares,
          color: entry.fill,
        }
        return acc
      }, {}),
    }

    return { chartData: data, chartConfig: config, colorMap }
  }, [latestRebalance, colorPalette])

  const coinBreadcrumbsList = [
    { title: "Model Portfolio", link: "/model-portfolio" },
    { title: `${fileName}`, link: "" },
  ]

  const [cagrCalculate, setCagrCalculate] = useState()
  const [yearPerformace, setYearPerformance] = useState()

  const getCagrValue = async () => {
    const data = { advisor: advisorTag, modelName: ele?.name }
    try {
      const response = await fetch(`${server.ccxtServer.baseUrl}rebalance/performance/cagr`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "X-Advisor-Subdomain": process.env.REACT_APP_URL,
          "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
        },
      })

      const result = await response.json()

      setCagrCalculate(result)
    } catch (error) {}
  }
  const getPerformaceValue = async () => {
    const data = { advisor: advisorTag, modelName: ele?.name }
    try {
      const response = await fetch(`${server.ccxtServer.baseUrl}rebalance/performance/2y_returns`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "X-Advisor-Subdomain": process.env.REACT_APP_URL,
          "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
        },
      })
      const result = await response.json()
      setYearPerformance(result)
    } catch (error) {}
  }
  useEffect(() => {
    getCagrValue()
    getPerformaceValue()
  }, [])
  const IndexSelector = ({ selectedIndex, onIndexChange }) => {
    const indices = [{ symbol: "^NSEI", name: "Nifty 50" }]

    return (
      <div className="mb-4 flex justify-end items-center">
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 mb-1">Compare with Index</label>
          <select
            value={selectedIndex}
            onChange={(e) => onIndexChange(e.target.value)}
            className="mt-1 block w-[200px] border-2 border-gray-300 pl-3 pr-10 py-2 text-base 
          focus:outline-none focus:ring-2 focus:ring-[#1F54DB] focus:border-[#1F54DB] 
          sm:text-sm rounded-md shadow-sm hover:border-gray-400"
          >
            {indices?.map((index) => (
              <option key={index.symbol} value={index.symbol} className="border-b border-gray-200 py-2">
                {index.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    )
  }

  const PerformanceChart = ({ modelName }) => {
    const chartRef = useRef(null)
    const [selectedIndex, setSelectedIndex] = useState("^NSEI")
    const [portfolioData, setPortfolioData] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const fetchIndexData = async () => {
      try {
        const tomorrow = new Date()
        tomorrow.setDate(tomorrow.getDate() + 1)
        const endDate = tomorrow.toISOString().split("T")[0]

        const startDate = new Date(Date.now() - 366 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]

        const response = await fetch(
          `${server.ccxtServer.baseUrl}misc/data-fetcher?symbol=${selectedIndex}&start_date=${startDate}&end_date=${endDate}`,
          {
            headers: {
              "X-Advisor-Subdomain": process.env.REACT_APP_URL,
              "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
            },
          },
        )
        const data = await response.json()
        return data.data
      } catch (error) {
        console.error("Error fetching index data:", error)
        return []
      }
    }

    const fetchPortfolioData = async () => {
      try {
        const response = await fetch(`${server.ccxtServer.baseUrl}rebalance/get-portfolio-performance`, {
          method: "POST",
          body: JSON.stringify({ advisor: advisorTag, modelName }),

          headers: {
            "Content-Type": "application/json",
            "X-Advisor-Subdomain": process.env.REACT_APP_URL,
            "aq-encrypted-key": encryptApiKey(process.env.REACT_APP_AQ_KEYS, process.env.REACT_APP_AQ_SECRET),
          },
        })
        if (!response.ok) {
          console.error(`API error: ${response.status}`)
          return []
        }

        const data = await response.json()

        if (data.status === 0 && data.message === "No performance data found.") {
          console.info("No performance data available for this portfolio")
          return []
        }

        return data.data || []
      } catch (error) {
        console.error("Error fetching portfolio data:", error)
        return []
      }
    }
    useEffect(() => {
      const loadData = async () => {
        setLoading(true)
        const [portfolio, indexData] = await Promise.all([fetchPortfolioData(), fetchIndexData()])

        // Find earliest common date
        const portfolioDates = portfolio?.map((p) => new Date(p.date).toISOString().split("T")[0])
        const indexDates = indexData?.map((n) => new Date(n.Date).toISOString().split("T")[0])
        const startDate = portfolioDates[0]
        // Get initial values
        const firstPortfolioValue =
          portfolio?.find((p) => new Date(p.date).toISOString().split("T")[0] === startDate)?.value || 100

        const firstIndexValue =
          indexData?.find((n) => new Date(n.Date).toISOString().split("T")[0] === startDate)?.Close || 100
        const alignedData = portfolio
          ?.map((p) => {
            const pDate = new Date(p.date).toISOString().split("T")[0]
            const matchingIndex = indexData?.find((n) => new Date(n.Date).toISOString().split("T")[0] === pDate)

            return {
              date: pDate,
              portfolioValue: (p.value / firstPortfolioValue) * 100,
              indexValue: matchingIndex ? (matchingIndex.Close / firstIndexValue) * 100 : null,
              actualIndexValue: matchingIndex?.Close || null,
            }
          })
          .filter((d) => d.indexValue !== null)

        console.log(
          "Compared Performance Data:",
          alignedData?.map((d) => ({
            date: d.date,
            portfolioValue: d.portfolioValue,
            niftyValue: d.indexValue,
            actualNiftyValue: d.actualIndexValue,
          })),
        )
        const sortedData = [...alignedData].sort((a, b) => {
          return new Date(a.date) - new Date(b.date)
        })
        setPortfolioData(sortedData)
        setLoading(false)
      }

      loadData()
    }, [selectedIndex, modelName])

    useEffect(() => {
      if (!portfolioData.length) return
      const ctx = chartRef.current?.getContext("2d")
      if (!ctx) return

      const portfolioValues = portfolioData.map((d) => d.portfolioValue)
      const indexValues = portfolioData.map((d) => d.actualIndexValue)

      const normalizedPortfolioData = portfolioValues.map((value, index) =>
        index === 0 ? 100 : (value / portfolioValues[0]) * 100,
      )

      const normalizedNiftyData = indexValues.map((value, index) =>
        index === 0 ? 100 : (value / indexValues[0]) * 100,
      )

      const chart = new Chart(ctx, {
        type: "line",
        data: {
          labels: portfolioData?.map((d) => new Date(d.date).toLocaleDateString()),
          datasets: [
            {
              label: "Portfolio Performance",
              data: normalizedPortfolioData,
              borderColor: "#1F54DB",
              backgroundColor: "rgba(31, 84, 219, 0.1)",
              yAxisID: "y",
              fill: true,
            },
            {
              label: "Nifty 50",
              data: normalizedNiftyData,
              borderColor: "#FF6B6B",
              yAxisID: "y",
              originalData: portfolioData.map((item) => item.actualIndexValue),
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.dataset.label || ""

                  if (label === "Nifty 50") {
                    const normalizedValue = context.raw
                    const originalValue = context.dataset.originalData[context.dataIndex]
                    return `${label}: ${normalizedValue.toFixed(2)} (${originalValue.toFixed(2)})`
                  } else {
                    return `${label}: ${context.formattedValue}`
                  }
                },
              },
            },
          },
          scales: {
            y: {
              display: true,
              beginAtZero: false,
              title: {
                display: true,
                text: "Performance (Base 100)",
              },
              min: (context) => {
                const values = context.chart.data.datasets.flatMap((dataset) => dataset.data)
                const minValue = Math.min(...values.filter((v) => v !== null && v !== undefined))
                return Math.min(Math.floor(minValue * 0.95), 90)
              },
              max: (context) => {
                const values = context.chart.data.datasets.flatMap((dataset) => dataset.data)
                const maxValue = Math.max(...values.filter((v) => v !== null && v !== undefined))
                return Math.max(Math.ceil(maxValue * 1.05), 102)
              },
            },
            x: {
              display: true,
            },
          },
        },
      })

      return () => chart.destroy()
    }, [portfolioData])

    if (error) {
      return <div className="flex items-center justify-center text-gray-500">{error}</div>
    }
    if (loading) {
      return (
        <div className="flex items-center justify-center h-64">
          <div className="w-16 h-16 relative">
            <div className="w-16 h-16 rounded-full border-4 border-[#E8EAF6] opacity-40"></div>
            <div className="w-16 h-16 rounded-full border-4 border-t-[#1F54DB] animate-spin absolute top-0 left-0"></div>
          </div>
        </div>
      )
    }

    if (!portfolioData.length) {
      return (
        <div className="flex items-center justify-center h-60 text-black text-2xl font-semibold">
          No data available to display
        </div>
      )
    }

    return (
      <div className="w-full">
        {portfolioData.length > 0 ? (
          <>
            <IndexSelector selectedIndex={selectedIndex} onIndexChange={setSelectedIndex} />
            <div style={{ height: "600px" }}>
              <canvas ref={chartRef} />
            </div>
          </>
        ) : (
          <div style={{ height: "400px" }} className="flex flex-col items-center justify-center">
            <svg className="w-16 h-16 text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p className="text-gray-500 text-center font-medium">
              {error || "No performance data available for this portfolio"}
            </p>
            <p className="text-gray-400 text-sm text-center mt-2">
              Performance data will appear as the portfolio matures
            </p>
          </div>
        )}
      </div>
    )
  }

  // Performance metrics component for mobile view
  const MobilePerformanceMetrics = () => {
    if (!strategyDetails?.performance_data) return null

    return (
      <div className="w-full flex flex-col py-4 mt-6">
        <h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center">
          <BarChart3Icon className="h-5 w-5 mr-2 text-[#1F54DB]" />
          Performance Metrics
        </h3>

        {/* Returns Section */}
        <div className="bg-[#FAFBFF] rounded-xl p-5 mb-5 shadow-sm border border-gray-100/80">
          <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
            <ArrowUpRightIcon className="h-4 w-4 mr-1.5 text-green-500" />
            Returns
          </h4>
          <div className="grid grid-cols-2 gap-3">
            {[
              {
                label: "CAGR",
                value: strategyDetails.performance_data.returns?.cagr || 0,
                isPercent: true,
                icon: <TrendingUp className="h-3.5 w-3.5 text-green-500" />,
              },
              {
                label: "Total",
                value: strategyDetails.performance_data.returns?.total || 0,
                isPercent: true,
                icon: <ArrowUpRightIcon className="h-3.5 w-3.5 text-green-500" />,
              },
              {
                label: "YTD",
                value: strategyDetails.performance_data.returns?.ytd || 0,
                isPercent: true,
                icon: <BarChart3Icon className="h-3.5 w-3.5 text-blue-500" />,
              },
              {
                label: "1Y",
                value: strategyDetails.performance_data.returns?.["1y"] || 0,
                isPercent: true,
                icon: <TimerIcon className="h-3.5 w-3.5 text-purple-500" />,
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex flex-col p-3 bg-gray-50 rounded-lg border border-gray-100 hover:shadow-sm transition-all duration-200"
              >
                <div className="flex items-center mb-1">
                  {item.icon}
                  <span className="text-xs text-gray-500 ml-1">{item.label}</span>
                </div>
                <span className={`text-sm font-medium ${Number(item.value) >= 0 ? "text-green-600" : "text-red-600"}`}>
                  {item.isPercent ? `${(Number(item.value) * 100).toFixed(2)}%` : Number(item.value).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Risk Metrics */}
        <div className="bg-[#FAFBFF] rounded-lg p-4 mb-4 shadow-sm border border-gray-100">
          <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
            <BarChart3Icon className="h-4 w-4 mr-1.5 text-[#1F54DB]" />
            Risk Metrics
          </h4>
          <div className="space-y-2.5">
            {[
              {
                label: "Volatility",
                value: strategyDetails.performance_data.risk?.volatility,
                isPercent: true,
              },
              { label: "VaR", value: strategyDetails.performance_data.risk?.var, isPercent: true },
              { label: "CVaR", value: strategyDetails.performance_data.risk?.cvar, isPercent: true },
              {
                label: "Ulcer Index",
                value: strategyDetails.performance_data.risk?.ulcer_index,
                isPercent: false,
              },
            ].map((item, index) => (
              <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded-md">
                <span className="text-xs text-gray-600 font-medium">{item.label}</span>
                <span className="text-sm font-medium text-gray-800">
                  {item.isPercent
                    ? `${(Number(item.value || 0) * 100).toFixed(2)}`
                    : Number(item.value || 0).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full relative flex flex-col max-h-[calc(100vh-60px)] lg:min-h-screen bg-[#FAFBFF]">
      <Toaster position="top-center" reverseOrder={true} />

      <div className="w-full grid grid-cols-12 h-[calc(100vh-120px)] overflow-y-auto lg:min-h-full">
        <div className="col-span-12 px-4 lg:col-span-8 xl:col-span-9 xl:px-[60px]">
          {/* Main Content Area */}
          <div className="flex flex-col space-y-6 py-6">
            <Breadcrumb breadcrumbsList={coinBreadcrumbsList} />

            {/* Strategy Header */}
            <div className="flex space-x-6  p-6 rounded-xl shadow-sm border border-gray-100/80">
            <div className="flex items-center justify-center">
                <img
                  src={strategyDetails?.image ? `${server.server.baseUrl}${strategyDetails.image}` : Alpha100}
                  alt={strategyDetails?.model_name}
                  className="w-16 h-16 sm:w-20 sm:h-20  object-contain"
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = Alpha100
                  }}
                />
              </div>
              <div className="flex justify-center flex-col">
                <div className="flex items-center space-x-4">
                  <h3 className="text-[22px] font-sans font-bold capitalize text-[#1F54DB] leading-tight">
                    {fileName?.replaceAll(/_/g, " ")}
                  </h3>
                </div>
                <p className="text-[14px] font-normal font-poppins text-black/60 mt-2 max-w-3xl">
                  {strategyDetails?.overView}
                </p>
              </div>
            </div>

            {/* Mobile Performance Stats */}
            <div className=" flex-col space-y-6 pb-8 hidden">
              <div className="flex justify-evenly gap-4">
                <div className="flex-1 bg-gradient-to-br from-[#E8EAF6] to-white rounded-xl p-4 shadow-sm border border-[#C5CAE9]/30">
                  <div className="text-[14px] text-black/70 font-poppins font-semibold mb-1">CAGR</div>
                  <p className="text-[20px] text-[#1F54DB] font-poppins font-bold">
                    {strategyDetails?.performance_data?.returns?.cagr
                      ? `${Number(strategyDetails.performance_data.returns.cagr).toFixed(2)}%`
                      : "New portfolio"}
                  </p>
                </div>
                <div className="flex-1 bg-gradient-to-br from-[#E8EAF6] to-white rounded-xl p-4 shadow-sm border border-[#C5CAE9]/30">
                  <div className="text-[14px] text-black/70 font-poppins font-semibold mb-1">2Y Returns</div>
                  <p className="text-[20px] text-[#1F54DB] font-poppins font-bold">
                    {yearPerformace?.performace ? `+ ${yearPerformace.performace}%` : "New portfolio"}
                  </p>
                </div>
              </div>
            </div>

            {/* Tabs Section */}
            <div className="flex flex-col space-y-4 bg-white rounded-xl shadow-sm overflow-hidden mt-6 border border-gray-100">
              <div className="flex items-center justify-between border-b border-gray-200 px-6 pt-4 pb-0">
                <div className="flex overflow-x-auto no-scrollbar space-x-4 md:space-x-8 w-full">
                  <div
                    className={`${selectedDataTab === "distribution" ? style.selected : style.unselected} pb-3 whitespace-nowrap`}
                    onClick={() => setSelectedDataTab("distribution")}
                  >
                    Distribution
                  </div>
                  <div
                    className={`${selectedDataTab === "whyStrategy" ? style.selected : style.unselected} pb-3 whitespace-nowrap`}
                    onClick={() => setSelectedDataTab("whyStrategy")}
                  >
                    Why this Strategy
                  </div>
                  <div
                    className={`${selectedDataTab === "methodology" ? style.selected : style.unselected} pb-3 whitespace-nowrap`}
                    onClick={() => setSelectedDataTab("methodology")}
                  >
                    Methodology
                  </div>
                </div>
                <button className="p-2 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0">
                  <Share2Icon className="h-5 w-5 text-[#1F54DB]" />
                </button>
              </div>
            </div>

            {/* Tab Content */}
            {selectedDataTab === "distribution" && (
              <div className="w-full flex flex-col space-y-6 py-6">
                <div className="text-[14px] text-black/60 font-normal font-poppins">
                  Check Latest Rebalance Updates issued by the Manager.
                  <span
                    className="ml-2 cursor-pointer text-[14px] text-[#1F54DB] font-normal font-poppins"
                    onClick={() => setShowRebalanceTimelineModal(true)}
                  >
                    View Rebalance History
                  </span>
                </div>

                {/* Rebalance Info Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:w-full xl:max-w-4xl mt-4">
                  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100/80 flex flex-col">
                    <h4 className="text-[14px] text-black/50 font-normal font-poppins mb-1">Last Rebalance</h4>
                    <p className="text-[18px] text-black font-semibold font-poppins">
                      {moment(strategyDetails?.last_updated).format("MMM DD, YYYY")}
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100/80 flex flex-col">
                    <h4 className="text-[14px] text-black/50 font-normal font-poppins mb-1">Next Rebalance</h4>
                    <p className="text-[18px] text-black font-semibold font-poppins">
                      {moment(strategyDetails?.nextRebalanceDate).format("MMM DD, YYYY")}
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100/80 flex flex-col">
                    <h4 className="text-[14px] text-black/50 font-normal font-poppins mb-1">Rebalance Frequency</h4>
                    <p className="text-[18px] text-black font-semibold font-poppins">{strategyDetails?.frequency}</p>
                  </div>
                </div>

                <div className="w-full flex flex-col space-y-6 py-2">
                  {userDetails?.user_broker === "null" ||
                    (!userDetails?.user_broker && (
                      <div className="mb-6 p-5 border border-[#BBDEFB] bg-gradient-to-r from-[#E3F2FD] to-white rounded-xl shadow-sm">
                        <div className="flex items-start">
                          <div className="rounded-full bg-[#1F54DB]/10 p-2 mr-3 mt-0.5">
                            <Info className="h-5 w-5 text-[#1F54DB]" />
                          </div>
                          <div>
                            <p className="text-sm text-gray-800 font-poppins font-medium leading-relaxed">
                              This is a simulated portfolio based on the model portfolio rebalances. If you wish to
                              execute the model portfolio in this platform and see live performance,
                              <a href="/subscriptions" className="text-[#1F54DB] hover:underline font-semibold ml-1">
                                connect your broker here
                              </a>
                              .
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                {/* Performance Chart Section */}
                <div className="w-full mt-6">
                  <h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center">
                    <BarChart3Icon className="h-5 w-5 mr-2 text-[#1F54DB]" />
                    Portfolio Performance
                  </h3>
                  <div className="bg-white rounded-xl shadow-sm p-6 h-[550px] border border-gray-100/80">
                    <PerformanceChart modelName={strategyDetails?.model_name} />
                  </div>
                </div>

                {/* Mobile Performance Metrics */}
                <div className="lg:hidden">
                  <MobilePerformanceMetrics />
                </div>
              </div>
            )}

            {selectedDataTab === "whyStrategy" && (
              <div className="flex flex-col space-y-6 py-6 px-6">
                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100/80">
                  <div className="flex items-start mb-4">
                    <div className="p-2 bg-[#E8EAF6] rounded-full mr-4">
                      <Info className="h-6 w-6 text-[#1F54DB]" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-[#1F54DB] mb-2">Why Choose This Strategy</h3>
                      <p className="text-[14px] leading-relaxed font-normal font-poppins text-black/70">
                        {strategyDetails?.whyThisStrategy}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Mobile Performance Metrics */}
                <div className="lg:hidden">
                  <MobilePerformanceMetrics />
                </div>
              </div>
            )}

{selectedDataTab === "methodology" && (
  <div className="flex flex-col space-y-8 py-6 px-6">
    {[
      { title: "Defining the universe", content: strategyDetails?.definingUniverse },
      { title: "Research", content: strategyDetails?.researchOverView },
      { title: "Constituent Screening", content: strategyDetails?.constituentScreening },
      { title: "Weighting", content: strategyDetails?.weighting && !isNaN(parseFloat(strategyDetails.weighting)) 
        ? parseFloat(strategyDetails.weighting).toFixed(2) 
        : strategyDetails?.weighting },
      { title: "Rebalance", content: strategyDetails?.rebalanceMethodologyText },
      ...(strategyDetails?.assetAllocationText !== ""
        ? [{ title: "Asset Allocation", content: strategyDetails?.assetAllocationText }]
        : []),
    ].map((section, index) => (
      <div key={index} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100/80">
        <h3 className="text-lg font-semibold text-[#1F54DB] mb-3 flex items-center">
          <div className="w-2 h-6 bg-[#1F54DB] rounded mr-2.5"></div>
          {section.title}
        </h3>
        <div className="mt-2 text-[14px] leading-relaxed font-normal font-poppins text-black/70">
          {(() => {
            const contentStr = String(section.content || '');
            const processedContent = contentStr.replace(/\/n/g, '\n');
            const lines = processedContent.split('\n')
              .map(line => line.trim())
              .filter(line => line.length > 0);
            
            return lines.length > 1 
              ? lines.map((line, i) => <p key={i} className="mb-2">{line}</p>)
              : <p>{section.content}</p>;
          })()}
        </div>
      </div>
    ))}


                {/* Mobile Performance Metrics */}
                <div className="lg:hidden">
                  <MobilePerformanceMetrics />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
          <div className="flex flex-col space-y-6 px-6 py-10">
            {subscribed ? (
              <button
                className="w-full py-3 px-4 rounded-lg font-medium text-[16px] text-white relative overflow-hidden transition-all duration-300"
                style={{
                  background: "linear-gradient(135deg, #1e40af, #3b82f6, #1e40af)",
                  backgroundSize: "200% 100%",
                  boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                }}
              >
                <span className="relative z-10 flex items-center justify-center">
                  Subscribed
                </span>
                <div
                  className="absolute inset-0 w-full h-full transition-all duration-500 opacity-0 hover:opacity-20"
                  style={{
                    background: "linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.8) 50%, transparent 75%)",
                    backgroundSize: "200% 200%",
                    animation: "shine 1.5s infinite",
                  }}
                ></div>
              </button>
            ) : (
              <button
                onClick={handleSubscribe}
                className={`w-full py-3 px-4 rounded-lg font-medium text-[16px] ${appConfig.colors.button}   text-white relative overflow-hidden transition-all duration-300`}
                style={{
                  backgroundSize: "200% 100%",
                  boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundPosition = "100% 0"
                  e.currentTarget.style.transform = "translateY(-2px)"
                  e.currentTarget.style.boxShadow = "0 6px 15px rgba(59, 130, 246, 0.4)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundPosition = "0% 0"
                  e.currentTarget.style.transform = "translateY(0)"
                  e.currentTarget.style.boxShadow = "0 4px 10px rgba(59, 130, 246, 0.3)"
                }}
              >
                <span className="relative z-10 flex items-center justify-center">
                  Invest Now
                  <ArrowRight className="w-4 h-4 ml-1.5 transition-transform duration-300" />
                </span>
                <div
                  className="absolute inset-0 w-full h-full transition-all duration-500 opacity-0 hover:opacity-20"
                  style={{
                    background: "linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.8) 50%, transparent 75%)",
                    backgroundSize: "200% 200%",
                    animation: "shine 1.5s infinite",
                  }}
                ></div>
              </button>
            )}

            {/* Performance Metrics Section - Replacing Volatility */}
            {strategyDetails?.performance_data ? (
              <div className="w-full flex flex-col py-4">
                <h3 className="text-xl font-bold mb-6 text-gray-800 flex items-center">
                  <BarChart3Icon className="h-5 w-5 mr-2 text-[#1F54DB]" />
                  Performance Metrics
                </h3>

                {/* Returns Section */}
                <div className="bg-white rounded-xl p-5 mb-5 shadow-sm border border-gray-100/80 hover:shadow-md transition-all duration-300">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <ArrowUpRightIcon className="h-4 w-4 mr-1.5 text-green-500" />
                    Returns
                  </h4>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      {
                        label: "CAGR",
                        value: strategyDetails.performance_data.returns?.cagr || 0,
                        isPercent: true,
                        icon: <TrendingUp className="h-3.5 w-3.5 text-green-500" />,
                      },
                      {
                        label: "Total",
                        value: strategyDetails.performance_data.returns?.total || 0,
                        isPercent: true,
                        icon: <ArrowUpRightIcon className="h-3.5 w-3.5 text-green-500" />,
                      },
                      {
                        label: "YTD",
                        value: strategyDetails.performance_data.returns?.ytd || 0,
                        isPercent: true,
                        icon: <BarChart3Icon className="h-3.5 w-3.5 text-blue-500" />,
                      },
                      {
                        label: "1Y",
                        value: strategyDetails.performance_data.returns?.["1y"] || 0,
                        isPercent: true,
                        icon: <TimerIcon className="h-3.5 w-3.5 text-purple-500" />,
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-col p-3 bg-gray-50 rounded-lg border border-gray-100 hover:shadow-sm transition-all duration-200 hover:bg-gray-50/80"
                      >
                        <div className="flex items-center mb-1">
                          {item.icon}
                          <span className="text-xs text-gray-500 ml-1">{item.label}</span>
                        </div>
                        <span
                          className={`text-sm font-medium ${Number(item.value) >= 0 ? "text-green-600" : "text-red-600"}`}
                        >
                          {item.isPercent ? `${(Number(item.value) * 100).toFixed(2)}%` : Number(item.value).toFixed(2)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Risk Metrics */}
                <div className="bg-white rounded-lg p-4 mb-4 shadow-sm border border-gray-100">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <BarChart3Icon className="h-4 w-4 mr-1.5 text-[#1F54DB]" />
                    Risk Metrics
                  </h4>
                  <div className="space-y-2.5">
                    {[
                      {
                        label: "Volatility",
                        value: strategyDetails.performance_data.risk?.volatility,
                        isPercent: true,
                      },
                      { label: "VaR", value: strategyDetails.performance_data.risk?.var, isPercent: true },
                      { label: "CVaR", value: strategyDetails.performance_data.risk?.cvar, isPercent: true },
                      {
                        label: "Ulcer Index",
                        value: strategyDetails.performance_data.risk?.ulcer_index,
                        isPercent: false,
                      },
                    ].map((item, index) => (
                      <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded-md">
                        <span className="text-xs text-gray-600 font-medium">{item.label}</span>
                        <span className="text-sm font-medium text-gray-800">
                          {item.isPercent
                            ? `${(Number(item.value || 0) * 100).toFixed(2)}`
                            : Number(item.value || 0).toFixed(2)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Drawdown Metrics */}
                <div className="bg-white rounded-lg p-4 mb-4 shadow-sm border border-gray-100">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <ArrowDownRightIcon className="h-4 w-4 mr-1.5 text-red-500" />
                    Drawdown
                  </h4>
                  <div className="space-y-2.5">
                    <div className="flex justify-between items-center p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-600 font-medium">Max Drawdown</span>
                      <span className="text-sm font-medium text-red-600">
                        {(Number(strategyDetails.performance_data.drawdown?.max_drawdown || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between items-center p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-600 font-medium">Avg Drawdown</span>
                      <span className="text-sm font-medium text-red-600">
                        {(Number(strategyDetails.performance_data.drawdown?.avg_drawdown || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between items-center p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-600 font-medium">Longest DD (Days)</span>
                      <span className="text-sm font-medium text-gray-800">
                        {strategyDetails.performance_data.drawdown?.longest_dd_days || "-"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Ratios */}
                <div className="bg-white rounded-lg p-4 mb-4 shadow-sm border border-gray-100">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <TimerIcon className="h-4 w-4 mr-1.5 text-purple-500" />
                    Ratios
                  </h4>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { label: "Sharpe", value: strategyDetails.performance_data.ratios?.sharpe, isColored: true },
                      { label: "Sortino", value: strategyDetails.performance_data.ratios?.sortino, isColored: true },
                      {
                        label: "Profit Factor",
                        value: strategyDetails.performance_data.ratios?.profit_factor,
                        isColored: false,
                      },
                      {
                        label: "Gain to Pain",
                        value: strategyDetails.performance_data.ratios?.gain_to_pain,
                        isColored: false,
                      },
                    ].map((item, index) => (
                      <div key={index} className="flex flex-col p-2 bg-gray-50 rounded-md">
                        <span className="text-xs text-gray-500 mb-1">{item.label}</span>
                        <span
                          className={`text-sm font-medium ${
                            item.isColored
                              ? Number(item.value || 0) >= 0
                                ? "text-green-600"
                                : "text-red-600"
                              : "text-gray-800"
                          }`}
                        >
                          {Number(item.value || 0).toFixed(2)}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Timing & General */}
                <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <Share2Icon className="h-4 w-4 mr-1.5 text-amber-500" />
                    Timing & General
                  </h4>
                  <div className="grid grid-cols-2 gap-3 mb-3">
                    <div className="flex flex-col p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-500 mb-1">Win Rate</span>
                      <span className="text-sm font-medium text-gray-800">
                        {(Number(strategyDetails.performance_data.timing?.win_rate || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                    <div className="flex flex-col p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-500 mb-1">Best Day</span>
                      <span className="text-sm font-medium text-green-600">
                        {(Number(strategyDetails.performance_data.timing?.best_day || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                    <div className="flex flex-col p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-500 mb-1">Worst Day</span>
                      <span className="text-sm font-medium text-red-600">
                        {(Number(strategyDetails.performance_data.timing?.worst_day || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                    <div className="flex flex-col p-2 bg-gray-50 rounded-md">
                      <span className="text-xs text-gray-500 mb-1">Time in Market</span>
                      <span className="text-sm font-medium text-gray-800">
                        {(Number(strategyDetails.performance_data.general?.time_in_market || 0) * 100).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <div className="mt-3 pt-3 border-t border-gray-200 flex items-center justify-between">
                    <span className="text-xs text-gray-500">Period</span>
                    <div className="text-xs text-gray-700 font-medium bg-gray-100 px-2 py-1 rounded">
                      {strategyDetails.performance_data.general?.start_date || "-"} to{" "}
                      {strategyDetails.performance_data.general?.end_date || "-"}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full flex flex-col py-6">
                {/* Strategy metrics list */}
                <div className="flex items-center border-b border-black/20 py-4 space-x-3">
                  <div className="flex items-center justify-center">
                    <img src={VolatilityIcon || "/placeholder.svg"} className="h-[26px] w-[26px]" alt="Volatility" />
                  </div>
                  <div className="flex items-center text-[14px] text-black/80 font-poppins font-medium">
                    Volatility:
                    <p className="ml-2 text-[14px] text-black font-poppins font-medium">Low</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Bottom CTA */}
      <div className="lg:hidden flex items-center w-full h-[80px] shadow-[0px_-4px_12px_0px_#0000000f] px-4 bg-white border-t border-gray-100">
        {subscribed ? (
          <button
            className="w-full py-3 px-4 rounded-lg font-medium text-[16px] text-white relative overflow-hidden transition-all duration-300"
            style={{
              background: "linear-gradient(135deg, #1e40af, #3b82f6, #1e40af)",
              backgroundSize: "200% 100%",
              boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
            }}
          >
            <span className="relative z-10 flex items-center justify-center">
              Subscribed
              <Eye className="w-4 h-4 ml-1.5 transition-transform duration-300" />
            </span>
            <div
              className="absolute inset-0 w-full h-full transition-all duration-500 opacity-0 hover:opacity-20"
              style={{
                background: "linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.8) 50%, transparent 75%)",
                backgroundSize: "200% 200%",
                animation: "shine 1.5s infinite",
              }}
            ></div>
          </button>
        ) : (
          <button
            onClick={handleSubscribe}
            className="w-full py-3 px-4 rounded-lg font-medium text-[16px] text-white relative overflow-hidden transition-all duration-300"
            style={{
              background: "linear-gradient(135deg, #1e40af, #3b82f6, #1e40af)",
              backgroundSize: "200% 100%",
              boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
            }}
          >
            <span className="relative z-10 flex items-center justify-center">
              Invest Now
              <ArrowRight className="w-4 h-4 ml-1.5 transition-transform duration-300" />
            </span>
            <div
              className="absolute inset-0 w-full h-full transition-all duration-500 opacity-0 hover:opacity-20"
              style={{
                background: "linear-gradient(45deg, transparent 25%, rgba(255,255,255,0.8) 50%, transparent 75%)",
                backgroundSize: "200% 200%",
                animation: "shine 1.5s infinite",
              }}
            ></div>
          </button>
        )}
      </div>

      {/* Modals */}
      {openSubscribeModel && (
        <UserStrategySubscribeModal
          setOpenSubscribeModel={setOpenSubscribeModel}
          userEmail={userEmail}
          getStrategyDetails={getStrategyDetails}
          strategyDetails={strategyDetails}
          fileName={fileName}
          latestRebalance={latestRebalance}
          userDetails={userDetails}
          setOpenSucessModal={setOpenSucessModal}
          setOrderPlacementResponse={setOrderPlacementResponse}
          setOpenTokenExpireModel={setOpenTokenExpireModel}
          setBrokerModel={setBrokerModel}
          clientCode={clientCode}
          apiKey={apiKey}
          secretKey={secretKey}
          jwtToken={jwtToken}
          viewToken={viewToken}
          sid={sid}
          serverId={serverId}
          broker={broker}
        />
      )}

      {openSuccessModal && (
        <RecommendationSuccessModal
          setOpenSucessModal={setOpenSucessModal}
          orderPlacementResponse={orderPlacementResponse}
          setStockDetails={setStrategyDetails}
          openSuccessModal={openSuccessModal}
          setShowAfterPlaceOrderDdpiModal={setShowAfterPlaceOrderDdpiModal}
        />
      )}

      {brokerModel && (
        <ConnectBroker
          uid={userDetails?._id}
          userDetails={userDetails}
          setBrokerModel={setBrokerModel}
          getUserDetails={getUserDetails}
          broker={broker}
          setBroker={setBroker}
          brokerModel={brokerModel}
        />
      )}

      {openTokenExpireModel && (
        <TokenExpireBrokarModal
          openTokenExpireModel={openTokenExpireModel}
          setOpenTokenExpireModel={setOpenTokenExpireModel}
          userId={userId}
          apiKey={apiKey}
          secretKey={secretKey}
          checkValidApiAnSecret={checkValidApiAnSecret}
          clientCode={clientCode}
          my2pin={my2pin}
          panNumber={panNumber}
          mobileNumber={mobileNumber}
          broker={broker}
          getUserDetails={getUserDetails}
        />
      )}

      {showRebalanceTimelineModal && (
        <RebalanceTimeLineModal
          closeRebalanceTimelineModal={() => setShowRebalanceTimelineModal(false)}
          strategyDetails={strategyDetails}
        />
      )}

      {paymentModal && (
        <PlanSubscribeModal
          userEmail={userEmail}
          strategyDetails={planDetails}
          paymentModal={paymentModal}
          setPaymentModal={setPaymentModal}
          handleCardClick={handleCardClickSelect}
          selectedCard={selectedCard}
          handleOk={handleOk}
          loading={loading}
          invetAmount={invetAmount}
          setInvestAmount={setInvestAmount}
          mobileNumber={mobileNumber}
          panNumber={panNumber}
          name={userName}
        />
      )}

      {paymentSuccess && (
        <PaymentSuccessModal
          specificPlanDetails={specificPlan}
          setPaymentSuccess={setPaymentSuccess}
          setSelectedCard={setSelectedCard}
          setOpenSubscribeModel={setOpenSubscribeModel}
        />
      )}
    </div>
  )
}

export default StrategyDetails
